<template>
  <v-card
    flat
    class="ma-3 pa-6"
  >
    <v-row align="center" class="pl-0 mb-6 pt-3 pr-3">
      <v-card-title>
        Stofbestellingen overzicht
      </v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        outlined
        dense
        v-model="filter.query"
        label="Zoek..."
        single-line
        hide-details
        clearable
        clear-icon="fa-times"
        @keydown.enter="search()"
        @click:clear="search()"
      ></v-text-field>
    </v-row>

    <v-card
      flat
      v-for="(offer, index) in offers"
      :key="'offer_'+index"
      class="mb-8"
    >

      <v-card-title>{{ offer.offer_number }} - {{ offer.customer.name }}</v-card-title>

      <v-data-table
        :headers="headers"
        :items="offer.offer_lines"
        :loading="isSearching"
        disable-pagination
        disable-sort
        disable-filtering
        hide-default-footer
        @click:row="rowClick"
      >

        <template v-slot:item.offer_line_status_id="{ item }">
          <v-chip
            small
            dark
            :color="getOfferLineStatusColor(item.offer_line_status_id)"
          >{{ item.offer_line_status.name }}</v-chip>
        </template>

        <template v-slot:item.studio_mailed_at="{ item }">
          {{ formatDate(item.studio_mailed_at) }}
        </template>

        <template v-slot:item.unit_price="{ item }">
          {{ formatCurrency(item.unit_price) }}
        </template>

        <template v-slot:item.price="{ item }">
          {{ formatCurrency(item.price) }}
        </template>

      </v-data-table>

    </v-card>


    <v-dialog
      v-model="productDialog"
      max-width="700"
      persistent
    >
      <v-card>
        <v-toolbar color="title" dark flat short class="px-2">
          <v-toolbar-title>Offerteregel</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="productDialog = false" icon><v-icon>fas fa-times</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="mt-12">

          <v-form
            ref="fabricForm"
            @submit.prevent
          >

            <v-textarea
              outlined
              v-model="offerLineProduct.options_remarks"
              label="Overige opmerkingen"
            ></v-textarea>

          </v-form>


        </v-card-text>

        <v-card-actions class="px-6 pb-8">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-5"
            large
            outlined
            depressed
            @click="productDialog = false"
          >Annuleren</v-btn>
          <v-btn
            color="primary"
            class="px-5"
            large
            depressed
            @click="saveProduct()"
          >Opslaan</v-btn>
        </v-card-actions>


      </v-card>

    </v-dialog>

  </v-card>
  
</template>

<script>
import Vue, { inject, computed, ref, reactive, getCurrentInstance } from 'vue'
import DatePicker from '@/components/DatePicker'
import moment from 'moment'
import { formatCurrency, formatDate, getOfferLineStatusColor, OFFER_STATUS_ORDERED, OFFER_LINE_STATUS_ORDERED, OFFER_LINE_STATUS_RECEIVED, OFFER_LINE_STATUS_SCHEDULED, OFFER_LINE_STATUS_DELIVERED } from '@/utils'

export default {
  components: {
    DatePicker,
  },
  setup(props) {
    const api = inject('api')
    const { proxy } = getCurrentInstance()

    const offerCollection = api.resource('offers').collection({
      params: {
        expand: 'offer_lines,customer,offer_lines.supplier,offer_lines.offer_line_status,offer_lines.product',
        filter: {
          offer_status_id: { eq: OFFER_STATUS_ORDERED },
          offer_line_status_id: { in: [OFFER_LINE_STATUS_ORDERED, OFFER_LINE_STATUS_RECEIVED, OFFER_LINE_STATUS_SCHEDULED, OFFER_LINE_STATUS_DELIVERED] },
          studio_supplier_id: { 'neq': 'NULL' },
        },
      },
      rules: {
        query: 'query:contact_name,company_name,address,city,offer_number',
      },
    })

    offerCollection.all()

    const { items: offers, filter, isSearching, search } = offerCollection

    const headers = [
      { text: 'Status', value: 'offer_line_status_id', sortable: false },
      { text: 'Omschrijving', value: 'description', sortable: false },
      { text: 'Leverancier', value: 'supplier.company_name', sortable: false },
      { text: 'Atelier gemaild datum', value: 'studio_mailed_at', sortable: false },
      { text: 'Aantal', value: 'quantity', sortable: false },
      { text: 'Stuksprijs', value: 'unit_price', sortable: false },
      { text: 'Prijs', value: 'price', sortable: false },
    ]

    const productDialog = ref(false)

    const offerLineProductModel = api.resource('offer-line-products').model()

    const { attributes: offerLineProduct } = offerLineProductModel

    function rowClick(offerLine) {
      offerLineProductModel.populate(offerLine.product)
      productDialog.value = true
    }

    function saveProduct() {
      offerLineProductModel.save().then(() => {
        offerCollection.all()
        productDialog.value = false
      })
    }


    
    return {
      headers,
      offers,
      filter,
      search,
      isSearching,
      rowClick,
      offerLineProduct,
      productDialog,
      saveProduct,
      formatCurrency,
      getOfferLineStatusColor,
      formatDate,
    }

  },
}
</script>


<style scoped>

::v-deep .v-data-table table tbody tr:not(.v-data-table__empty-wrapper):hover {
  cursor: pointer;
}


</style>
